import { useParams } from "react-router-dom";
import { useGetUserOrderDetailsQuery } from "src/store/apis/client";
import { explode } from "src/utility";
import PointsExchangeDetailsWeb from "./layouts/PointsExchangeDetails.web";
import { useTranslation } from "react-i18next";
import NoData from "@Components/NoData/NoData";

export default function PointsExchangeDetails() {
  const { id } = useParams();
  const {t, i18n} = useTranslation();
  const { data, isFetching, error } = useGetUserOrderDetailsQuery<{ data: any; isFetching: boolean; error: unknown }>({
    referenceNumber: id,
    lang:i18n.language
  });
  const { orderItems, statusEnum, total, referenceNumber, orderedAt } = explode(data, {});

  if (!isFetching && error) {
    return (
      <div className="flex w-full flex-1 items-center justify-center">
        <NoData description={t("UserHistory.orderDetails.detailsUnavailable")} className="h-full w-full" />
      </div>
    );
  }

  return (
    <PointsExchangeDetailsWeb
      isFetching={isFetching}
      orderItems={orderItems}
      statusEnum={statusEnum}
      total={total}
      referenceNumber={referenceNumber}
      orderedAt={orderedAt}
    />
  );

}
